<template>
  <div class="register registration-start" v-if="!sent">
    <!--<loginComponent/>-->
    <div class="row justify-content-center mb-50">
      <div class="col-10">
        <h1 class="text-center mb-30">Registriere dich jetzt!</h1>
      </div>
      <div class="col-8 col-lg-6">
        <h5 class="text-center">
          Gib hier deine Daten ein. Danach erhältst du eine
          <nobr>E-Mail</nobr> von uns mit den nächsten Schritten.
        </h5>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-lg-5">
        <div class="mandatory-note text-center">
          <p>* Pflichtfelder bitte ausfüllen</p>
        </div>

        <form>
          <div class="col-12">
            <h5>Persönliche Daten</h5>
          </div>
          <div class="form-row">
            <div class="mb-40 mt-30 col-12 floating-label">
              <span v-if="valid('firstname')" class="invalid-feedback">Bitte Vornamen eingeben!</span>
              <input
                type="text"
                class="form-control"
                placeholder="Vorname Eltern"
                v-validate="'required'"
                name="firstname"
                v-model="firstname"
              />
              <label>Vorname Elternteil*</label>
            </div>
          </div>
          <div class="form-row">
            <div class="mb-40 mt-30 col-12 floating-label">
              <span v-if="valid('lastname')" class="invalid-feedback">Bitte Nachnamen eingeben!</span>
              <input
                type="text"
                class="form-control"
                placeholder="Nachname Eltern"
                v-validate="'required'"
                name="lastname"
                v-model="lastname"
              />
              <label>Nachname Elternteil*</label>
            </div>
          </div>
          <div class="form-row">
            <div class="mb-40 mt-30 col-12 floating-label">
              <span
                v-if="valid('email')"
                class="invalid-feedback"
              >Bitte gültige E-Mail-Adresse eingeben!</span>
              <input
                type="email"
                class="form-control"
                placeholder="E-Mail"
                v-validate="'required|email'"
                name="email"
                v-model="email"
              />
              <label>E-Mail-Adresse Elternteil*</label>
            </div>
          </div>

          <div class="form-row">
<!--            <div class="mb-40 mt-30 col-4 floating-label">-->
<!--              <span-->
<!--                  v-if="valid('mobile')"-->
<!--                  class="invalid-feedback"-->
<!--              >Bitte gültige Telefonnummer eingeben!</span>-->
<!--              <select-->
<!--                  class="form-control"-->
<!--                  placeholder="mobile"-->
<!--                  v-validate="{ required: true, regex:/^\+?[1-9]\d{1,14}$/ }"-->
<!--                  name="mobilePrefix"-->
<!--                  v-model="mobilePrefix"-->
<!--              >-->
<!--                <option v-for="(option, i) in options" :value="option.value" :key="i">-->
<!--                  {{ option.text }}-->
<!--                </option>-->
<!--              </select>-->
<!--              <label>Telefonnummer Elternteil*</label>-->
<!--            </div>-->


            <!--COUNTRY PHONE PREFIX-->
            <div class="form-group col-4">
              <label class="standalone">Ländervorwahl *</label>
<!--              <div v-if="errors.first('mobilePrefix')" class='invalid-feedback'>Bitte Ländervorwahl auswählen!</div>-->
              <b-form-select
                             name="mobilePrefix"
                             v-model="mobilePrefix"
                             class="mb-0"
                             >
                <option v-for="(option, i) in countryOptions" :value="option.value" :key="i">
                                    {{ option.text }}
                                  </option>
              </b-form-select>
            </div>

            <!--MOBILE PHONE NUMBER-->
            <div class="mb-40 mt-30 col-8 floating-label">
              <span
                  v-if="valid('mobilePhoneNumber')"
                  class="invalid-feedback"
              >Bitte gültige Telefonnummer eingeben!</span>
              <input
                  type="text"
                  class="form-control"
                  placeholder="mobile"
                            v-validate="{ required: true, regex:selectedCountryMobileNumberRegex }"
                  name="mobilePhoneNumber"
                  v-model="mobilePhoneNumber"
                  @blur='removeLeadingZero'
              />
<!--              @blur="removeLeadingZero"-->
<!--              v-validate="{ required: true, regex:/(1[5-7])/ }"-->
<!--              v-validate="{ required: true, regex:selectedCountryMobileNumberRegex }"-->
              <label>Telefonnummer Elternteil*</label>
            </div>
          </div>


<!--          <div class="form-group mb-30">-->
<!--            <label class="standalone">Teilnahmebedingungen und Datenschutzhinweise*:</label>-->
<!--            <div class="form-check">-->
<!--              <input class="form-check-input" type="checkbox" v-validate="'required'" name="conditionsAgreement" id="conditionsAgreement" v-model="conditionsAgreement">-->
<!--              <label class="form-check-label" for="conditionsAgreement">-->
<!--                Ich akzeptiere die Teilnahmebedingung und habe die <a href="https://www.mcdonalds.com/content/dam/sites/de/unreferenced/Datenschutz/Datenschutzinformationen_McDonalds_Junior_Club.pdf" target="_blank">Datenschutzhinweise</a> zur Kenntnis genommen.-->
<!--              </label>-->
<!--            </div>-->
<!--          </div>-->

          <div class="form-group mb-30">
            <label class="standalone">Nutzungsbedingungen und Datenschutzhinweise**:</label>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" v-validate="'required'" name="conditionsAgreement" id="conditionsAgreement" v-model="conditionsAgreement">
              <label class="form-check-label" for="conditionsAgreement">
                Ich akzeptiere die
                <a href="https://www.mcdonalds.com/content/dam/sites/de/unreferenced/nutzungsbedingungen/Nutzungsbedingungen_Junior_Club.pdf" target="_blank">Nutzungsbedingungen</a>
                und habe die
                <a href="https://www.mcdonalds.com/content/dam/sites/de/unreferenced/Datenschutz/Datenschutzinformationen_McDonalds_Junior_Club.pdf" target="_blank">Datenschutzhinweise</a> zur Kenntnis genommen.
              </label>
            </div>
          </div>

          <div v-if="registerOld">
            <div class="col-12">
              <h5>Aktivierungscode</h5>

              <p class="small">
                Du hast keinen Aktivierungscode? Dann
                <router-link to="/registrierung">registriere dich hier</router-link>!
              </p>
            </div>
            <div class="form-row">
              <div class="mb-40 mt-30 col-12 floating-label">
                <span
                  v-if="valid('activationcode')"
                  class="invalid-feedback"
                >Bitte Aktivierungscode eingeben!</span>
                <b-form-input
                  type="text"
                  class="form-control"
                  name="activationcode"
                  v-validate="'required|min:10|max:10'"
                  v-model="activationCode"
                  placeholder="Aktivierungscode Eltern"
                />
                <label>Dein persönlicher Aktivierungscode*</label>
                <button id="activecode" class="btn-tooltip">i</button>
                <b-tooltip target="activecode" placement="top">
                  Den Aktivierungscode findest du in deinem letzten
                  Aktionsmailing.
                </b-tooltip>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-4 col-lg-2 text-center">
        <button
          @click="sendRegistration"
          :disabled="!completed"
          type="button"
          class="btn btn-primary bg-gradient-primary mb-30"
        >Absenden</button>
      </div>
    </div>
  </div>

  <div v-else>
    <div class="row justify-content-center">
      <div class="col-10">
        <h2 class="text-center">Vielen Dank!</h2>
        <h5 class="text-center">
          Wir haben dir eine Bestätigung per E-Mail zugesendet. Bitte überprüfe
          jetzt deinen Posteingang und schließe deine Anmeldung ab.
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import { apiRegistration } from "../utils/api";

export default {
  name: "registerStartView",
  data() {
    return {
      firstname: "",
      lastname: "",
      email: "",
      mobilePrefix:'49',
      mobilePhoneNumber:"",
      countryOptions: [
        { name: '', value: '49', text: '+49', regex: ''},
        { name: '', value: '45', text: '+45', regex: ''},
        { name: '', value: '48', text: '+48', regex: ''},
        { name: '', value: '420', text: '+420', regex: ''},
        { name: '', value: '43', text: '+43', regex: ''},
        { name: '', value: '41', text: '+41', regex: ''},
        { name: '', value: '33', text: '+33', regex: ''},
        { name: '', value: '352', text: '+352', regex: ''},
        { name: '', value: '32', text: '+32', regex: ''},
        { name: '', value: '31', text: '+31', regex: ''},
        { name: '', value: '380', text: '+380', regex: ''}
      ],
      // phoneNumberValidationRefreshed: true,
      activationCode: "",
      conditionsAgreement: false,
      sent: false,
      error: false
    };
  },
  vuelidation: {
    data: {
      firstname: {
        required: true
      },
      lastname: {
        required: true
      },
      email: {
        required: true,
        email: true
      },
      mobile: {
        required: true,
        mobile: true
      },
      conditionsAgreement: {
        required: true,
        conditionsAgreement: true
      },
    }
  },
  created(){
  },
  mounted(){
  },
  methods: {
    // refreshInput() {
    //   this.phoneNumberValidationRefreshed = false
    //   this.phoneNumberValidationRefreshed = true
    // },
    removeLeadingZero() {
      const number = parseInt(this.mobilePhoneNumber)
      this.mobilePhoneNumber = number || ''
    },
    sendRegistration() {
      let params = {};

      if (this.$route.path === "/aktivierung")
        params = {
          email: this.email,
          firstname: this.firstname,
          lastname: this.lastname,
          mobile: this.mobilePhoneNumberComplete,
          activationCode: this.activationCode
        };
      else
        params = {
          email: this.email,
          firstname: this.firstname,
          lastname: this.lastname,
          mobile: this.mobilePhoneNumberComplete
        };

      apiRegistration(params)
        .then(response => {
          if (response.data.code === 0) {
            this.$router.push({ hash: "#erfolgreich" });
            return (this.sent = true);
          } else if (response.data.code === 1)
            this.toast(
              "E-Mail-Adresse bereits registriert. Bitte logge dich über den Login-Bereich ein."
            );
          else if (response.data.code === 2)
            this.toast("Bestätigungs-E-Mail konnte nicht versendet werden");
          else if (response.data.code === 3)
            this.toast("Die Registrierung ist nicht möglich. Bitte wenden Sie sich an den Gästeservice.");
          else if (response.data.code === 4)
            this.toast("Mobilnummer bereits registriert");
          else if (response.data.code === 99)
            this.toast("Pflichtfeld nicht ausgefüllt");
          else if (response.data.code === 100)
            this.toast("Ungültige oder unzulässige E-Mail-Adresse");
          else if (response.data.code === 103)
            this.toast("Ungültiger Aktivierungscode");
          else if (response.data.code === 104)
            this.toast(
              "Registrierung fehlgeschlagen. Bitte versuchen Sie es später erneut."
            );
          else this.toast(response.data.message);
        })
        .catch(e => {
          this.$store.commit("error", e);
        });
    },
    toast(text) {
      this.$toasted.error(text, {
        duration: 3000,
        position: "bottom-right"
      });
    },
    valid(name) {
      return (
        this.fields[name] &&
        this.fields[name].touched &&
        !this.fields[name].valid
      );
    }
  },
  computed: {
    mobilePhoneNumberComplete() {
      return this.mobilePrefix + parseInt(this.mobilePhoneNumber)
    },
    completed() {
      return (
        Object.keys(this.fields).every(key => this.fields[key].validated) &&
        Object.keys(this.fields).every(key => this.fields[key].valid)
      );
    },
    registerOld() {
      return this.$route.path === "/aktivierung";
    },
    selectedCountryMobileNumberRegex() {
      // old: /^\+?[1-9]\d{1,14}$/
      // let countryRegex = /(49(1[5-7]))/ //default Germany
      let countryRegex = /(1[5-7])/ //default Germany
      if(this.mobilePrefix === '45') { // Daenemark
        countryRegex = ''
      } else if(this.mobilePrefix === '48') { // Polen
        countryRegex = ''
      } else if(this.mobilePrefix === '420') { // Tschechien
        countryRegex = ''
      } else if(this.mobilePrefix === '43') { // Oesterreich+Mobilvorwahlen 650-699
        countryRegex = /(6[5-9][0-9])/
      } else if(this.mobilePrefix === '41') { // Schweiz+Mobilvorwahlen 76-79
        countryRegex = /(7[6-9])/
      } else if(this.mobilePrefix === '33') { //Frankreich+Mobilvorwahl 6
        countryRegex = /(6)/
      } else if(this.mobilePrefix === '32') {
        countryRegex = /(4)/ // Belgien+Mobilvorwahl 4
      } else if(this.mobilePrefix === '31') {
        countryRegex = /(6)/ // Niederlande+Mobilvorwahl 6
      } else if(this.mobilePrefix === '352') {
        countryRegex = /(6)/ // Luxemburg+Mobilvorwahl 6
      } else if(this.mobilePrefix === '380') {
        countryRegex = /(6)/ // Ukraine+Mobilvorwahl 6
      } else {
        // countryRegex = '/(49(1[5-7]))/' // Deutschland
      }

      return countryRegex
    },
  }
};
</script>

<style>
.modal-header .close {
  display:none;
}
</style>
